import { apiGet } from 'utils/API/actions/request'
import { PAYMENTS_NEGOTIATION } from '../constants'

export const getNegotiationPayments = (appId, page, size) => apiGet({
  entity: PAYMENTS_NEGOTIATION,
  url: `/paymentnegotiation/${appId}?Page=${page}&PageLength=${size}`,
  isChainable: true,
  hasPagination: true
})
